import React, { useState } from 'react';
import { InputContainer } from '../../../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../../../common/components/accordion/accordion.module';
import PlansListContainer from './plans-list/plans-list.container';
import moment from 'moment';


export const SmsCampaignBasicInfoComponent = ({

  selectedSms, onInnerBasicFormChange, campaignFrequency, PolicyOwnerType,
  tagNames, handleSelectedTemplates
}: any) => {
  const [showPlans, setShowPlans] = useState(false);
  const [error, setError] = useState("");
  return (
    <>
      <AccordionContainer
        child={
          <div className=' grid md:grid-cols-2 lg:grid-cols-2 gap-3'>
            <InputContainer
              label="Name"
              name="Name"
              onValueChange={(event: any) => {
                onInnerBasicFormChange(
                  event.target.value,
                  'Name'
                )
              }}
              type="text"
              value={selectedSms?.Name}
            />

            <InputContainer
              label="Campaign Frequency"
              labelField="Text"
              isLoading={PolicyOwnerType}
              list={campaignFrequency}
              onValueChange={(event: any) => {
                onInnerBasicFormChange(
                  event.target.value,
                  'FrequencyId'
                );
              }}
              optionName='Choose Campaign Frequency'
              type="select"
              value={selectedSms?.FrequencyId}
              valueField="Value"
            />

          </div>
        }

        expandedPanel="BasicInfo"
        headerTitle="Basic Info"
      />
      <div className="shadow-card box-border px-4 my-4 border-2 rounded-lg">
        <h5 className="font-semibold text-lg mb-3 border-b pb-2 flex items-center gap-2">

          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" color="#000000" fill="none">
            <path d="M2 6L8.91302 9.91697C11.4616 11.361 12.5384 11.361 15.087 9.91697L22 6" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"></path>
            <path d="M2.01577 13.4756C2.08114 16.5412 2.11383 18.0739 3.24496 19.2094C4.37608 20.3448 5.95033 20.3843 9.09883 20.4634C11.0393 20.5122 12.9607 20.5122 14.9012 20.4634C18.0497 20.3843 19.6239 20.3448 20.7551 19.2094C21.8862 18.0739 21.9189 16.5412 21.9842 13.4756C22.0053 12.4899 22.0053 11.5101 21.9842 10.5244C21.9189 7.45886 21.8862 5.92609 20.7551 4.79066C19.6239 3.65523 18.0497 3.61568 14.9012 3.53657C12.9607 3.48781 11.0393 3.48781 9.09882 3.53656C5.95033 3.61566 4.37608 3.65521 3.24495 4.79065C2.11382 5.92608 2.08114 7.45885 2.01576 10.5244C1.99474 11.5101 1.99475 12.4899 2.01577 13.4756Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"></path>
          </svg>
          Email Details
        </h5>
        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-3">
          {/* <InputContainer
          label="Reply To"
          type="multiselectText"
          value={selectedSms?.ReplyToEmailInclusions}
          onValueChange={(newValue: any) => {
            const valueData = newValue.map((option: any) => option?.id || "");
            onInnerBasicFormChange(valueData, "ReplyToEmailInclusions");
          }}
        /> */}
          <InputContainer
            label="Recipient"
            labelField="displayText"
            list={tagNames}
            type="multiselect"
            valueField="Id"
            value={selectedSms?.RecipientTagIdInclusions}
            onValueChange={(newValue: any) => {
              const categoryData = newValue.map((option: any) => option?.value || "");
              onInnerBasicFormChange(categoryData, "RecipientTagIdInclusions");
            }}
          />

        </div>
      </div>
       {
              <AccordionContainer
                child={
                  <>
                    <div className="grid md:grid-cols-3 lg:grid-cols-3 gap-3">
                      <div className="mr-2">
                        <InputContainer
                          label="Start Date"
                          name="StartDate"
                          onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                              moment(event.target.value).utc().format("YYYY-MM-DDTHH:mm"),
                              "StartDate"
                            );
                          }}
                          type="date"
                          value={selectedSms?.StartDate}
                        />
                      </div>
      
                      <div className="mr-2">
                        <InputContainer
                          label="End Date"
                          name="EndDate"
                          onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                              moment(event.target.value).utc().format("YYYY-MM-DDTHH:mm"),
                              "EndDate"
                            );
                          }}
                          type="date"
                          value={selectedSms?.EndDate}
                        />
                      </div>
                      <div className='flex w-full justify-start items-start'>
                       <button
                        type="button"
                        className="m-6 bg-blue-700 text-white rounded font-medium px-4 py-3"
                        onClick={() => {
                          if (selectedSms?.StartDate && selectedSms?.EndDate) {
                            setShowPlans(true);
                            setError("");
                          } else {
                            setShowPlans(false);
                            setError("Enter from and to date");
                          }
                        }}
                      >
                        Show Plans
                      </button>
                      </div>
                    
      
                    </div>
      
                    {error && <p className="text-danger mt-2">{error}</p>}
      
                    {showPlans && (
                      <PlansListContainer
                        key={`${selectedSms?.StartDate}-${selectedSms?.EndDate}`}
                        handleSelectedTemplates={handleSelectedTemplates}
                        selectedSms={selectedSms}
                      />
                    )}
                  </>
                }
                expandedPanel="Templates"
                headerTitle="Select a template"
              />
            }
    </>
  )
}

export default SmsCampaignBasicInfoComponent;
